import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import _ from 'lodash';
import styled from 'styled-components';
import { 
  MenuList,
  MenuItem as MuMenuItem,
  Tooltip,
  Popper as MuPopper
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const SplitButton = ({
  options,
  onSelect,
  value,
  multiple,
  tooltipText = 'Help text'
}) => {
  const theme = useTheme();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleMenuItemClick = index => {
    if (!multiple) setOpen(false);
    onSelect(options[index]);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const parsedValue = String(value || '').replace(/[^0-9,]/g, '');
  const displayLabel = parsedValue
    ? _.truncate(parsedValue, { length: 12 })
    : 'OTHER';

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ width: 'inherit' }}
    >
      <Grid item xs={12}>
        <ButtonGroup
          variant={displayLabel !== 'OTHER' ? 'contained' : 'outlined'}
          color="primary"
          ref={anchorRef}
          aria-label="split button"
        >
          <Tooltip title={tooltipText} placement="top">
            <Button
              color="primary"
              size="small"
              aria-controls={open ? 'split-button-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-label="select merge strategy"
              aria-haspopup="menu"
              onClick={handleToggle}
              style={{
                borderRadius: '0px 4px 4px 0px',
                fontSize: 11,
                height: 31
              }}
            >
              {displayLabel}
              <ArrowDropDownIcon style={{ fontSize: 16, marginLeft: 5 }} />
            </Button>
          </Tooltip>
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom'
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        selected={parsedValue.includes(option)}
                        onClick={() => handleMenuItemClick(index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
    </Grid>
  );
};

SplitButton.propTypes = {
  options: PropTypes.array,
  onSelect: PropTypes.func,
  value: PropTypes.string,
  multiple: PropTypes.bool,
  tooltipText: PropTypes.string
};

const MenuItem = styled(MuMenuItem)`
  color: ${({ selected }) => (selected ? '#ff9800 !important' : 'inherit')};
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  font-size: 12px !important;
`;

const Popper = styled(MuPopper)`
  z-index: 100;
`;
